import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function QrCodeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M14 14H17V17H14V14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20 14H23V17H20V14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 17H20V20H17V17Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14 20H17V23H14V20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20 20H23V21C23 22.1046 22.1046 23 21 23H20V20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C2.3457 1 1 2.3457 1 4L1 10H10V1H4ZM3 4V8L8 8V3H4C3.44873 3 3 3.44824 3 4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 23C2.3457 23 1 21.6543 1 20L1 14H10V23H4ZM3 20V16L8 16V21H4C3.44873 21 3 20.5518 3 20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1C21.6543 1 23 2.3457 23 4V10H14V1H20ZM21 4V8L16 8V3H20C20.5513 3 21 3.44824 21 4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4 4H7V7H4V4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 4H20V7H17V4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4 17H7V20H4V17Z",
    fill: "currentColor"
  }));
}